module.exports = __webpack_public_path__ + "static/media/icon_07.fa5e60e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon_07.png
// module id = 1648
// module chunks = 1